export default "__VITE_ASSET__n$7rofXl__"